export interface CadRenderInvalidator {
  invalidate(reason: string): void
}

export const NOOP_CAD_RENDER_INVALIDATOR: CadRenderInvalidator = {
  invalidate() {},
}
